import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { LEFT_SIDE_BAR_SELECTED } from "../PartnerPortal/leftNavbar";
import { constructSelectedComponent } from "../../Factory/factory";
import { PAYMENT_COMPONENT } from "../Payments/paymentsWrapper";

function useHandleQuerySource() {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (
            queryParams.has("source") &&
            queryParams.get("source") === "paypal-connect"
        ) {
            dispatch({
                type: LEFT_SIDE_BAR_SELECTED,
                payload: constructSelectedComponent(PAYMENT_COMPONENT),
            });
            queryParams.delete("source");
            history.replace({
                search: queryParams.toString(),
            });
        }
    }, [location]);
}

export default useHandleQuerySource;
